import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FirebaseFeatureFlags } from '../../enums/firebase-custom-claims.enum';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private _flagsSubject = new BehaviorSubject<FirebaseFeatureFlags[]>([]);
  public flags$ = this._flagsSubject.asObservable();

  publishFlags(flags: FirebaseFeatureFlags[]) {
    this._flagsSubject.next(flags);
  }
}
